var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68906 42.9609C6.95283 42.9609 6.3271 42.7033 5.81186 42.1881C5.29666 41.6728 5.03906 41.0471 5.03906 40.3109C5.03906 39.5746 5.29666 38.9489 5.81186 38.4337C6.3271 37.9184 6.95283 37.6608 7.68906 37.6608H9.03906V10.3391C9.03906 8.86228 9.5532 7.60973 10.5815 6.58146C11.6097 5.5532 12.8623 5.03906 14.3391 5.03906H33.6608C35.1376 5.03906 36.3902 5.5532 37.4185 6.58146C38.4467 7.60973 38.9609 8.86228 38.9609 10.3391V37.6608H40.3109C41.0471 37.6608 41.6728 37.9184 42.1881 38.4337C42.7033 38.9489 42.9609 39.5746 42.9609 40.3109C42.9609 41.0471 42.7033 41.6728 42.1881 42.1881C41.6728 42.7033 41.0471 42.9609 40.3109 42.9609H7.68906ZM28 26C28.5666 26 29.0416 25.8083 29.425 25.425C29.8083 25.0416 30 24.5666 30 24C30 23.4333 29.8083 22.9583 29.425 22.575C29.0416 22.1916 28.5666 22 28 22C27.4333 22 26.9583 22.1916 26.575 22.575C26.1916 22.9583 26 23.4333 26 24C26 24.5666 26.1916 25.0416 26.575 25.425C26.9583 25.8083 27.4333 26 28 26Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.33ff654198e9eccc5949bc1d9ec0a0f6.svg";
export { ForwardRef as ReactComponent };